<section class="ft-master-section ft-cooperative-partners-master">
    <section class="ft-section">
        <div class="ft-container">
            <div class="ft-nav ft-navbar ft-contexttabs-nav">
                <ul>
                    <li class="active"><a>{{ partners().length }} Partners</a></li>
                </ul>
            </div>
            <div class="ft-contexttab-view active">
                <div class="ft-row">
                    @for (partner of partners(); track partner) {
                        <div class="ft-col-33">
                            <div class="ft-panel ft-org-panel" style="cursor: initial;">
                                <div class="ft-bg-image" [ftBackgroundImage]="partner.BackgroundImageUrl"></div>
                                <div class="ft-bg-matte"></div>
                                <div class="ft-content">
                                    <div class="ft-org-name">{{ partner.DisplayName || partner.Name }}</div>
                                    <div class="ft-org-type">Hotel</div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </section>
</section>
